import { Label } from '@hyperflake/react-ui-library';
import { CalendarIcon } from '@icon/index';
import { DatePicker } from '@library/datepicker';
import CameraInstallationList from 'modules/analytics/components/CameraInstallationList/CameraInstallationList';
import SignInLogsList from 'modules/analytics/components/SignInLogsList/SignInLogsList';
import useCameraInstallationData from 'modules/analytics/hooks/useCameraInstallationListData';
import useSignInLogsListData from 'modules/analytics/hooks/useSignInLogsListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import moment from 'moment';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const CameraInstallationPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialFilter = searchParams.get('filter') || 'ALL';

    const [startDate, setStartDate] = useState(moment().subtract(5, 'days').startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));

    const formattedStart = startDate.format('YYYY-MM-DD');
    const formattedEnd = endDate.format('YYYY-MM-DD');

    const { data, isLoading } = useCameraInstallationData(formattedStart, formattedEnd);

    return (
        <PageTemplate>
            <PageHeading className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="">Latest Installations</div>

                <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:gap-4">
                    {/* From Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">From Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={startDate.toDate()}
                                minDate={moment().subtract(30, 'days').toDate()}
                                maxDate={endDate.toDate()}
                                onChange={(date) => {
                                    const newStart = moment(date).startOf('day');
                                    setStartDate(newStart);
                                    if (newStart.isAfter(endDate)) setEndDate(newStart.endOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>

                    {/* To Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">To Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={endDate.toDate()}
                                minDate={startDate.toDate()}
                                maxDate={moment().toDate()}
                                onChange={(date) => {
                                    const newEnd = moment(date).endOf('day');
                                    setEndDate(newEnd);
                                    if (newEnd.isBefore(startDate)) setStartDate(newEnd.startOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>
                </div>
            </PageHeading>

            <div>
                <CameraInstallationList isLoading={isLoading} installations={data} />
            </div>
        </PageTemplate>
    );
};

export default CameraInstallationPage;
